// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-picker-container {
  width: 100%;
  max-width: 800px;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: Arial, sans-serif;
}

  
  .date-picker-container h2 {
    font-size: 1.5rem;
    color: #4a5b57;
    margin-bottom: 10px;
  }
  .hr {
    border-bottom: 1px solid #cfd8dc;
   margin-top: 2em;
   margin-bottom: 2em;
  }
  
/* Para las celdas de los días de la semana */
.react-datepicker__day-name {
  display: inline-flex;
  justify-content: center;
  width: 3rem;  /* Asegura que los nombres de los días de la semana tengan el mismo tamaño que las celdas de los días */
  font-size: 1.5rem;
  text-align: center;
  padding: 0.5rem 0;
}

.react-datepicker__navigation {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1.5rem;
}


.react-datepicker {
  font-size: 1.5rem; /* Aumenta el tamaño del calendario */
}

.react-datepicker__day {
  width: 3rem; /* Aumenta el tamaño de los días */
  height: 3rem;
  font-size: 1.5rem;
}

.react-datepicker__header {
  font-size: 1.5rem;
}

.react-datepicker__current-month,
.react-datepicker__day-name {
  font-size: 1.5rem;
}

.react-datepicker__navigation {
  width: 3rem;
  height: 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home/DatePickerComponent.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;;EAGE;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gCAAgC;GACjC,eAAe;GACf,kBAAkB;EACnB;;AAEF,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,uBAAuB;EACvB,WAAW,GAAG,uGAAuG;EACrH,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA;EACE,WAAW,EAAE,kCAAkC;EAC/C,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".date-picker-container {\n  width: 100%;\n  max-width: 800px;\n  height: 100vh;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: Arial, sans-serif;\n}\n\n  \n  .date-picker-container h2 {\n    font-size: 1.5rem;\n    color: #4a5b57;\n    margin-bottom: 10px;\n  }\n  .hr {\n    border-bottom: 1px solid #cfd8dc;\n   margin-top: 2em;\n   margin-bottom: 2em;\n  }\n  \n/* Para las celdas de los días de la semana */\n.react-datepicker__day-name {\n  display: inline-flex;\n  justify-content: center;\n  width: 3rem;  /* Asegura que los nombres de los días de la semana tengan el mismo tamaño que las celdas de los días */\n  font-size: 1.5rem;\n  text-align: center;\n  padding: 0.5rem 0;\n}\n\n.react-datepicker__navigation {\n  width: 2.5rem;\n  height: 2.5rem;\n  font-size: 1.5rem;\n}\n\n\n.react-datepicker {\n  font-size: 1.5rem; /* Aumenta el tamaño del calendario */\n}\n\n.react-datepicker__day {\n  width: 3rem; /* Aumenta el tamaño de los días */\n  height: 3rem;\n  font-size: 1.5rem;\n}\n\n.react-datepicker__header {\n  font-size: 1.5rem;\n}\n\n.react-datepicker__current-month,\n.react-datepicker__day-name {\n  font-size: 1.5rem;\n}\n\n.react-datepicker__navigation {\n  width: 3rem;\n  height: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
